import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output
} from "@angular/core";

@Component({
  selector: 'app-product-modal',
  templateUrl: './product-modal.component.html',
  styleUrls: ['./product-modal.component.scss']
})
export class ProductModalComponent implements OnInit {

  constructor(private _eref: ElementRef) {}

    @Input() show;
    @Input() item;
    @Output() close = new EventEmitter();
    ngOnInit() {
      console.log(this.item);
    }
    ngOnChanges() {
        console.log(this.show);
    }

    onClick() {
        this.close.emit("");
    }

}



// WEBPACK FOOTER //
// /Users/akirchhoff/Documents/Development/routerProducts/src/app/product-modal/product-modal.component.ts